/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/cat'
export default icon
